import log from "../log";

/**
 * Emojis are weird. This is a great article that inspired this solution:
 * https://backend.cafe/how-to-handle-emojis-in-nodejs.
 * Note: Firefox compatible since 125 (Released 2024-04-16)!
 */
export const strToArrWithEmojis = (str: string): string[] | null => {
	try {
		return [...new Intl.Segmenter().segment(str ?? "")].map(({ segment }) => segment);
	} catch (err) {
		log.warn(
			{ err },
			"Failed to convert string to emoji array. Most likely due to incompatibility with an old browser.",
		);
		return null;
	}
};

export const isEmojiOnlyStr = (str?: string | null): boolean | null => {
	if (!str) return false;
	str = str.replace(/\s/g, "");
	const strArr = strToArrWithEmojis(str);
	if (strArr) {
		const regexpEmoji = /\p{Emoji}/gu;
		const numEmojis = strArr.filter((s) => s.match(regexpEmoji)).length;
		return strArr.length === numEmojis;
	}
	return false;
};
